export default __webpack_public_path__ + "static/media/Medium.3605fb90.svg";